export default __webpack_public_path__ + "static/media/webhosting.5e79c8fa.svg";